const builtInRenderBackends = {
    Auto: 'auto',
    GPU: 'gpu',
    CPU: 'cpu',
};
const RenderBackends = builtInRenderBackends;
export function registerRenderBackendsConstant(name, backend) {
    if (Object.prototype.hasOwnProperty.call(RenderBackends, name)) {
        throw new Error(`Render backend constant "${String(name)}" already exists`);
    }
    RenderBackends[name] =
        backend;
}
export default RenderBackends;
